import { useWizard } from '../wizard-context';

import type { DiscountWizardOptions } from './types';

type ShowDiscountWizardOptions = DiscountWizardOptions & {
  discountId?: number | undefined;
};

export function useDiscountWizard() {
  const { getWizardState, showWizard, hideWizard } = useWizard();

  const state = getWizardState('discount');

  return {
    discountId: state.entityId,
    initialState: state.initialState,
    isWizardActive: state.isActive,
    showNotificationLink: state.options.showNotificationLink ?? false,
    showDiscountWizard: (options?: ShowDiscountWizardOptions) =>
      showWizard('discount', { ...options, entityId: options?.discountId }),
    hideDiscountWizard: () => hideWizard('discount'),
  };
}
